import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/myCars';
import { loadBookings } from './utils';

export default function* listenChangeStatusFilter() {
  yield takeEvery(actionTypes.changeStatusFilter.toString(), loadBookings);
}
